import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Rocket } from 'lucide-react';
import { Link } from 'react-router-dom';
export function LaunchCTA() {
  return <section className="py-20 px-6 bg-zinc-950 border-y border-zinc-900" data-id="element-49">
      <div className="max-w-3xl mx-auto text-center" data-id="element-50">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6
      }} data-id="element-51">
          <p className="text-sm uppercase tracking-widest text-zinc-500 font-medium mb-4" data-id="element-52">
            For builders & operators
          </p>
          <h2 className="font-serif text-3xl md:text-4xl mb-6 text-zinc-100" data-id="element-53">
            Want to know how to launch a platform like this?
          </h2>
          <p className="text-zinc-400 mb-10 text-lg" data-id="element-54">
            Hosting, infrastructure, scale, security — we've put together a deep
            dive on what it takes to run a platform like danceforfans.com.
          </p>
          <motion.div animate={{
          boxShadow: ['0 0 0 0 rgba(220, 38, 38, 0.7)', '0 0 0 16px rgba(220, 38, 38, 0)', '0 0 0 0 rgba(220, 38, 38, 0)'],
          scale: [1, 1.03, 1]
        }} transition={{
          duration: 1.6,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="inline-block rounded-full" data-id="element-55">
            <Link to="/launch" className="inline-flex items-center gap-3 px-10 py-5 bg-red-600 text-white rounded-full font-bold uppercase tracking-wider text-base md:text-lg hover:bg-red-500 transition-colors group shadow-lg shadow-red-600/40" data-id="element-56">
              <Rocket className="w-5 h-5" data-id="element-57" />
              Click Here For The Launch Guide
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-58" />
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}